import { render, staticRenderFns } from "./SubGroupListing.vue?vue&type=template&id=6e6a9563"
import script from "./SubGroupListing.vue?vue&type=script&lang=js"
export * from "./SubGroupListing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports